//
// DynamicRangeAttributesMap.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./DynamicReferenceContainer";
import "../../core/styles/attributesMap/RangeAttributesMap";

var DynamicRangeAttributesMap = createModule("gtl::DynamicRangeAttributesMap", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::Dynamic","gtl::DynamicReferenceContainer"], EventDispatcher, [
    ,
    {
        rangeAttributesMapNameDefault: 7,
        rangeAttributesMap: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DynamicRangeAttributesMap;
